import { starsFor } from '@shared/game/heat';
import { t } from '../i18n/ru';
import { useController } from '../state/context';
import { Check, Chevron, List } from './Icons';

export function BoardNav() {
  const c = useController();
  const game = c.game.value;
  const { index, total } = c.position.value;
  const passed = game ? c.progress.value[game.boardId] : undefined;
  const stars = passed?.heat != null ? starsFor('win', passed.heat) : 0;
  const locked = c.status.value === 'loading' || c.busy.value || c.generation.value !== null;
  return (
    <div class="nav">
      <button
        type="button"
        class="icon"
        aria-label="Предыдущее поле"
        title="Предыдущее поле"
        disabled={locked}
        onClick={() => void c.stepBoard(-1)}
      >
        <Chevron side="left" />
      </button>
      {/* key: при смене поля название «выезжает» заново. Нажатие открывает карту полей */}
      <button
        type="button"
        class="name swap"
        key={game?.boardId}
        data-testid="board-name"
        data-board-id={game?.boardId}
        aria-label={t.levels.open}
        title={t.levels.open}
        disabled={c.status.value === 'loading' && !game}
        onClick={() => c.openLevels()}
      >
        <span class="name-title">
          <span class="name-text">{game?.title ?? ' '}</span>
          {game && passed && (
            <span class={stars === 3 ? 'name-check gold' : 'name-check'} aria-hidden="true">
              <Check />
            </span>
          )}
        </span>
        <small>
          <List class="name-list" />
          {game ? t.boardMeta(index, total, game.generated, stars, !!passed) : ' '}
        </small>
      </button>
      <button
        type="button"
        class="icon"
        aria-label="Следующее поле"
        title="Следующее поле"
        disabled={locked}
        onClick={() => void c.stepBoard(1)}
      >
        <Chevron side="right" />
      </button>
      <button
        type="button"
        class="btn-new"
        title="ИИ придумает новое поле"
        disabled={locked}
        onClick={() => void c.generate()}
      >
        ✨ Новое
      </button>
    </div>
  );
}
